import {library} from '@fortawesome/fontawesome-svg-core';

import {
  faBoxTaped,
  faArrowDownToBracket,
  faArrowLeft,
  faArrowRightArrowLeft,
  faArrowRightFromBracket,
  faArrowRotateLeft,
  faArrowUpFromBracket,
  faArrowUpFromLine,
  faArrowUpFromSquare,
  faArrowUpRightFromSquare,
  faArrowUp,
  faBan,
  faBank,
  faBarcodeRead,
  faBars,
  faBarsFilter,
  faBell,
  faBlanket,
  faBuildingColumns,
  faBuildings,
  faCalendarCheck,
  faCalendarDay,
  faCalendarRange,
  faChartPieSimple,
  faChartSimple,
  faCheck,
  faCherries,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleUp,
  faCircleUser,
  faCircleXmark,
  faClockRotateLeft,
  faClock,
  faCoffee,
  faCoins,
  faComment,
  faCookieBite,
  faCreditCard,
  faDolly,
  faEllipsis,
  faEnvelope,
  faEnvelopeOpenText,
  faExternalLink,
  faEyeSlash,
  faF,
  faFileArrowDown,
  faFileCheck,
  faFileInvoice,
  faFileLines,
  faFileSlash,
  faGear,
  faGrid2,
  faHandHoldingDollar,
  faHeart,
  faHeartBroken,
  faHourglassEnd,
  faHourglassHalf,
  faInfoCircle,
  faLanguage,
  faLink,
  faLinkSimple,
  faLinkSlash,
  faList,
  faKey,
  faLock,
  faLockKeyhole,
  faMessages,
  faMeterBolt,
  faMinus,
  faMobile,
  faMoon,
  faPaintbrush,
  faPalette,
  faPaperclip,
  faPaperPlane,
  faPause,
  faPen,
  faPenCircle,
  faPercent,
  faPhone,
  faPiggyBank,
  faPlane,
  faPlay,
  faPlus,
  faQuestion,
  faRotate,
  faRotateLeft,
  faRotateRight,
  faScaleBalanced,
  faSearch,
  faSend,
  faShield,
  faShieldCheck,
  faShieldHalved,
  faShoppingBasket,
  faSignalBars,
  faSlidersSimple,
  faSparkles,
  faStar,
  faStore,
  faSun,
  faSunBright,
  faTag,
  faThumbsDown,
  faThumbsUp,
  faTrash,
  faTrashCan,
  faTriangleExclamation,
  faUser,
  faUserGroup,
  faWallet,
  faWarning,
  faXmark,
  faArrowsRotate,
  faEye,
  faBullhorn,
  faArrowDown,
  faCoinBlank,
  faCircleQuestion,
  faScrewdriverWrench,
  faGlobe,
  faCalendarCirclePlus,
  faReply,
  faRepeat,
  faBolt,
  faCircle1,
  faCircle2,
  faCircle3,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faGlobe as farGlobe,
  faFileInvoice as farFileInvoice,
  faBasketShopping as farBasketShopping,
  faCalendarCheck as farCalendarCheck,
  faCircle as farCircle,
  faCircleCheck as farCircleCheck,
  faCircleExclamation as farCircleExclamation,
  faCircleInfo as farCircleInfo,
  faCopy as farCopy,
  faGrid2 as farGrid2,
  faStar as farStar,
  faCalendarDay as farCalendarDay,
  faTriangleExclamation as farTriangleExclamation,
  faUser as farUser,
  faCloudExclamation as farCloudExclamation,
  faMagnifyingGlass as farMagnifyingGlass,
  faWallet as farWallet,
  faCalendar as farCalendar,
  faBolt as farBolt,
  faBuildingColumns as farBuildingColumns,
  faCircleXmark as farCircleXmark,
  faMobile as farMobile,
} from '@fortawesome/pro-regular-svg-icons';

library.add(
  farGlobe,
  faBoxTaped,
  faRotateLeft,
  faArrowLeft,
  faArrowRotateLeft,
  faArrowRightArrowLeft,
  faArrowRightFromBracket,
  faArrowUpFromSquare,
  faArrowUpRightFromSquare,
  faArrowUp,
  faBank,
  faBarcodeRead,
  faBars,
  faBarsFilter,
  farBasketShopping,
  faBell,
  faBlanket,
  faBuildings,
  faCalendarCheck,
  faCalendarRange,
  faChartPieSimple,
  faChartSimple,
  faCheck,
  faCherries,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronRight,
  faCircleCheck,
  farCircle,
  farCircleCheck,
  faCircleExclamation,
  farCircleExclamation,
  faCircleInfo,
  farCircleInfo,
  faCircleUp,
  faCircleUser,
  faCircleXmark,
  faClockRotateLeft,
  faClock,
  faCoffee,
  faCoins,
  faCreditCard,
  farCloudExclamation,
  faTriangleExclamation,
  farTriangleExclamation,
  faDolly,
  faEllipsis,
  faEnvelope,
  faEnvelopeOpenText,
  faExternalLink,
  faFileInvoice,
  faGlobe,
  faFileLines,
  faGear,
  faHandHoldingDollar,
  faHeart,
  faHeartBroken,
  faLanguage,
  faLinkSimple,
  faKey,
  faLock,
  faMessages,
  faMeterBolt,
  faMinus,
  faMobile,
  farMobile,
  faMoon,
  faPaintbrush,
  faPalette,
  faPaperclip,
  faPaperPlane,
  faPause,
  faPen,
  faPenCircle,
  faPercent,
  faPiggyBank,
  faPlay,
  faPlus,
  faQuestion,
  faRotate,
  farStar,
  faSearch,
  faSend,
  faShoppingBasket,
  faShield,
  faShieldCheck,
  faShieldHalved,
  faSignalBars,
  faSparkles,
  faStar,
  faStore,
  faSun,
  faTag,
  faThumbsUp,
  faUser,
  faUserGroup,
  faWallet,
  faXmark,
  faWarning,
  faLockKeyhole,
  faEyeSlash,
  faHourglassHalf,
  faFileSlash,
  farCopy,
  faThumbsDown,
  farUser,
  farCalendarCheck,
  farGrid2,
  faGrid2,
  faScaleBalanced,
  faF,
  faChevronUp,
  faCalendarDay,
  farCalendarDay,
  faSunBright,
  faTrash,
  faTrashCan,
  farBasketShopping,
  faInfoCircle,
  faArrowUpFromLine,
  faComment,
  faCookieBite,
  faPlane,
  faFileCheck,
  faArrowDownToBracket,
  faLink,
  faLinkSlash,
  faPhone,
  faHourglassEnd,
  faBan,
  faBarsFilter,
  faCalendarDay,
  faBuildingColumns,
  faEllipsis,
  faSlidersSimple,
  faArrowUpFromBracket,
  faSlidersSimple,
  faList,
  faRotateRight,
  faFileArrowDown,
  faArrowsRotate,
  farFileInvoice,
  faEye,
  faSlidersSimple,
  faBullhorn,
  faArrowDown,
  faCoinBlank,
  faCircleQuestion,
  faScrewdriverWrench,
  farMagnifyingGlass,
  farWallet,
  faCalendarCirclePlus,
  faReply,
  faRepeat,
  farCalendar,
  faBolt,
  farBolt,
  farBuildingColumns,
  faCircle1,
  faCircle2,
  faCircle3,
  farCircleXmark,
);
